import { FC } from 'react';
import { SkeletonWrapper } from '~/skeleton/common/skeleton-wrapper';
import { ArticleCardSkeleton } from '~/skeleton/common/article-card';
import { UserProfileSkeleton } from '~/skeleton/user/component';
import { SkeletonScanline } from '~/skeleton/common/skeleton-scanline';

export const UserFullSkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <UserProfileSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};

export const UserBodySkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};
